class ShippingIncentive {
  constructor() {
    this.threshold = 59;
    this.storageKey = 'shipping_incentive_threshold_reached';
    // Recupera lo stato da localStorage
    this.thresholdReached = localStorage.getItem(this.storageKey) === 'true';
    this.init();
  }

  init() {
    // Ascolta l'evento di aggiunta al carrello di Shopify
    document.addEventListener('cart:change', () => this.updateIncentive());
    
    // Fallback: ascolta anche i submit dei form prodotto
    document.addEventListener('submit', (e) => {
      if (e.target.classList.contains('js-product-form') || e.target.classList.contains('form')) {
        // Attendi che Shopify aggiorni il carrello (500ms delay)
        setTimeout(() => this.updateIncentive(), 500);
      }
    });

    // Ascolta anche gli eventi di Shopify cart
    if (window.Shopify && window.Shopify.cart) {
      document.addEventListener('shopify:cart:update', () => this.updateIncentive());
    }

    // Initial load
    this.updateIncentive();
  }

  updateIncentive() {
    // Fetch il carrello corrente tramite Shopify Cart API
    fetch('/cart.json')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100; // Converti da centesimi a euro
        const remaining = this.threshold - cartTotal;

        if (remaining > 0) {
          const remainingRounded = Math.ceil(remaining);
          this.updateDisplay(remainingRounded);
          // Se la soglia non è stata raggiunta, continua a mostrare l'incentivo
          this.thresholdReached = false;
          localStorage.setItem(this.storageKey, 'false');
        } else {
          // La soglia è stata raggiunta, mostra il messaggio celebrativo
          this.showCelebration();
          this.thresholdReached = true;
          localStorage.setItem(this.storageKey, 'true');
        }
      })
      .catch(error => console.error('Errore nel caricamento del carrello:', error));
  }

  updateDisplay(amount) {
    const incentiveElement = document.querySelector('.shipping-incentive');
    const amountElement = document.querySelector('.amount-highlight');

    if (!incentiveElement) return;

    // Se l'elemento non è visibile, mostralo
    if (incentiveElement.style.display === 'none' || !incentiveElement.offsetParent) {
      incentiveElement.style.display = 'block';
    }

    if (amountElement) {
      const currentAmount = parseInt(amountElement.textContent);
      
      // Se il valore è cambiato, attiva l'animazione
      if (currentAmount !== amount) {
        // Aggiungi classe di animazione
        amountElement.classList.add('amount-updating');
        
        // Aggiorna il valore
        amountElement.textContent = amount + '€';
        
        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
          amountElement.classList.remove('amount-updating');
        }, 600);

        // Anima il container
        incentiveElement.classList.add('incentive-updated');
        setTimeout(() => {
          incentiveElement.classList.remove('incentive-updated');
        }, 400);
      }
    }
  }

  showCelebration() {
    const incentiveElement = document.querySelector('.shipping-incentive');
    if (incentiveElement) {
      // Rimuovi le animazioni precedenti
      incentiveElement.classList.remove('fade-out');
      
      // Sostituisci il contenuto con il messaggio celebrativo
      incentiveElement.innerHTML = `
        <div class="shipping-incentive-content">
          <div class="shipping-incentive-icon">🎉</div>
          <div class="shipping-incentive-text">
            <p style="font-size: 16px; font-weight: 700; color: #8b7355; margin-bottom: 8px;">
              Complimenti, hai raggiunto la soglia minima!
            </p>
            <p class="secondary-text">
              Avrai la spedizione gratuita e 6 campioncini esclusivi nel tuo ordine!
            </p>
            <p style="font-size: 14px; color: #666666; margin-top: 10px; font-style: italic;">
              Procedi al checkout prima che cambiamo idea 😉
            </p>
          </div>
        </div>
      `;
      
      // Assicurati che sia visibile
      incentiveElement.style.display = 'block';
      
      // Aggiungi la classe di celebrazione
      incentiveElement.classList.add('celebration-mode');
    }
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ShippingIncentive();
  });
} else {
  new ShippingIncentive();
}
